import styled from "styled-components"
import { lighten } from "polished"

const Input = styled.input`
  border: 1px solid ${({ theme }) => theme.colors.grey1};
  border-radius: 3px;
  height: 50px;
  padding: 0 10px;
  width: 100%;
  :valid {
    background-color: ${({ theme }) => lighten(0.3, theme.colors.green)};
  }
`

export default Input
